var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.999 13.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.95 2.05a7 7 0 1 0 0 9.9 7 7 0 0 0 0-9.9zm-4.038 7.993a.913.913 0 1 1-1.826 0V6.391a.913.913 0 0 1 1.826 0zM6.983 4.83A.814.814 0 0 1 6.118 4a.814.814 0 0 1 .876-.843.84.84 0 1 1-.011 1.673z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoError);
export default __webpack_public_path__ + "static/media/info-error.64188343ec4c8af601ec034630f48019.svg";
export { ForwardRef as ReactComponent };